import { ActionType, ComponentType } from '../../enums';

export interface CreateFilterUpdateEventPayloadOptions {
  groupName: string;
  itemName: string;
  itemText: string;
  itemType: string;
  itemValue: string;
}

export interface CreateFilterUpdateEventPayloadReturn {
  event_data: {
    action: ActionType;
    component_type: ComponentType;
    group_name: string;
    item_name: string;
    item_text: string;
    item_type: string;
    item_value: string;
  };
}

export const CreateFilterUpdateEventPayload = ({
  groupName,
  itemName,
  itemText,
  itemType,
  itemValue,
}: CreateFilterUpdateEventPayloadOptions): CreateFilterUpdateEventPayloadReturn => {
  return {
    event_data: {
      action: ActionType.UPDATE,
      component_type: ComponentType.FILTER,
      group_name: groupName,
      item_name: itemName,
      item_text: itemText,
      item_type: itemType,
      item_value: itemValue,
    },
  };
};
